const comments = [
  {
    name: '吃瓜一线网友',
    time: '2小时前',
    content: '这个网站太绝了！每天必刷，国产51精品入口吃瓜爆料的速度比微博还快，网红最新爆料一个都不错过。编辑部是真的有料！',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20portrait%20of%20a%20young%20Asian%20person%2C%20soft%20warm%20lighting%2C%20simple%20cream%20background%2C%20editorial%20style%2C%20clean%20composition%2C%20modern%20professional%20headshot%20vibe&width=100&height=100&seq=avatar-01-chigua&orientation=squarish',
  },
  {
    name: '八卦精本精',
    time: '5小时前',
    content: '关注吃瓜网站半年了，网红吃瓜吃料网每日爆料的深度真的没话说。不像其他平台只会搬运，这里的精品吃瓜内幕经常有独家视角和分析。',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20portrait%20of%20a%20young%20Asian%20female%2C%20warm%20soft%20lighting%2C%20simple%20cream%20background%2C%20editorial%20style%2C%20clean%20composition%2C%20modern%20professional%20headshot%20vibe&width=100&height=100&seq=avatar-02-chigua&orientation=squarish',
  },
  {
    name: '娱乐圈老司机',
    time: '8小时前',
    content: '吃瓜爆料每日更新的频率真的服气！作为老吃瓜人，我敢说这里是目前全网信息最全、更新最快的网红吃瓜网站。推荐给所有爱八卦的朋友。',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20portrait%20of%20a%20mature%20Asian%20person%2C%20warm%20soft%20lighting%2C%20simple%20cream%20background%2C%20editorial%20style%2C%20clean%20composition%2C%20modern%20professional%20headshot%20vibe&width=100&height=100&seq=avatar-03-chigua&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2">瓜友热议</h2>
        <p className="text-sm text-foreground-500 mb-8">看看吃瓜网友都在聊什么</p>
        <div className="flex flex-col gap-4">
          {comments.map((cmt, idx) => (
            <div key={idx} className="p-5 rounded-lg bg-background-50 border border-background-200/60">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={cmt.avatar}
                    alt={cmt.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      const t = e.currentTarget;
                      t.style.display = 'none';
                    }}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-sm font-semibold text-foreground-900">{cmt.name}</span>
                    <span className="text-xs text-foreground-400">{cmt.time}</span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{cmt.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}